import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';
import { EmergencySchedule } from "../shared/models/emergency/schedule.model";

@Injectable({
    providedIn: 'root'
})
export class EmergencyService {

    emergencySchedules: Array<EmergencySchedule> = [];
    emergencyTiers: Array<any> = [];
    activitiesChanged: boolean = false;
    fte: number;
    cancelChanges: Function;
    updateViewAfterSave: Function;
    getCheckedActivities: Function;
    clearAll: Function;
    getAdHocActivities: Function;

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetEmergencyActivities(data) {
        return this.http.post('/api/Emergency/Activities', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ApplyChanges(data) {
        return this.http.post('/api/Emergency/ApplyEmergency', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    CancelChanges() {
        this.cancelChanges();
    }

    HasChanges() {
        return this.activitiesChanged;
    }

    Deactivate(data) {
        return this.http.post('/api/Emergency/DeactivateEmergency', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    handleSuccess(res) {
        return { success: true, data: res };
    }

    handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false, data: res };
    }
}